export const COPY = {
  pl: {
    nav: { drop: "DROP", lookbook: "LOOKBOOK", manifesto: "MANIFEST", signup: "ZAPISZ SIĘ" },
    hero: {
      kicker: "DROP 003 — WYBRZEŻE MAROKA",
      lines: ["SMOKE", "HASH", "STACK", "CASH"],
      sub: "Pierwszy T-shirt w historii SignUp. Legendarny item dla miłośników czekolady # <3 Ponton wypływa 14.09 o 14:20. Dopływamy do portu o 22:00, by nadać wasze paczki przed wypłynięciem transportu o poranku!",
      date: "14.09 — 14:20 CEST",
      cta1: "ZAPISZ SIĘ NA DROP",
      cta2: "ZOBACZ KOLEKCJĘ",
      live: "DROP ZA",
    },
    countdown: { days: "DNI", hours: "GODZ", minutes: "MIN", seconds: "SEK", label: "PREMIERA — 14 WRZEŚNIA, 14:20", waiting: "OSÓB CZEKA NA DROP", port: "NADANIE PACZEK W PORCIE — 22:00" },
    products: {
      kicker: "KOLEKCJA",
      title: "NA DROP'IE TYLKO KOSZULKA",
      tee: { name: "$MOKE HA$H STACK CA$H", price: "249 PLN", desc: "Pierwszy T-shirt w historii SignUp. Legendarny item dla miłośników czekolady # <3 Ponton wypływa 14.09 o 14:20. Dopływamy do portu o 22:00, by nadać wasze paczki przed wypłynięciem transportu o poranku!", size: "ROZMIAR", cta: "KUP TERAZ", available: "AVAILABLE", sizechart: "TABELA ROZMIARÓW", accuracy: "dokładność ± 2 cm", sold: "SPRZEDANO", left: "ZOSTAŁO", stockof: "Z 180 SZTUK", pcs: "SZT." },
      buy: { loading: "PRZEKIEROWANIE…", error: "Płatność chwilowo niedostępna — spróbuj za moment.", success: "Koszulka opłacona! Potwierdzenie leci na Twój e-mail.", cancel: "Płatność anulowana — koszulka czeka, jak coś." },
      soldout: "SOLD OUT",
    },
    modal: {
      title: "LISTA VIP",
      sub: "Zostaw e-mail — dostaniesz link 10 minut przed drop'em. Bez spamu, tylko sygnał.",
      placeholder: "twoj@email.pl",
      submit: "POWIADOM MNIE",
      success: "Jesteś na liście. Do zobaczenia 14.09 o 14:20.",
      duplicate: "Ten e-mail już jest na liście VIP.",
      error: "Coś poszło nie tak — spróbuj jeszcze raz.",
      invalid: "Podaj poprawny adres e-mail.",
    },
    manifesto: {
      kicker: "MANIFEST",
      chapters: [
        { n: "01", title: "MOROCCAN DRIP", body: "Kolekcja stworzona dla koneserów czekolady. Jeżeli jesteś frozen / static enthusiast, to na pewno zrozumiesz przekaz." },
        { n: "02", title: "WYKONANE W POLSCE Z PREMIUM BAWEŁNY", body: "Premium bawełna o gramaturze 260 gram! Koszulka, która nie spierze się po kilku praniach, i nadruk, który wytrzyma wszystkie warunki!" },
        { n: "03", title: "STACK CASH AND SMOKE HA$H!", body: "Mocno limitowany drop jak zawsze. Kupując teesa, automatycznie Ca$h stackuje się o wiele szybciej!" },
      ],
    },
    lookbook: { kicker: "LOOKBOOK", title: "TRASA: MAROCCO TRAP → PL TRAPHOUSE", sub: "" },
    footer: {
      newsletter: "Newsletter — tylko drop info, zero spamu.",
      placeholder: "twoj@email.pl",
      submit: "WYŚLIJ",
      rights: "© 2026 $IGN UP! — Wszystkie prawa zastrzeżone.",
      tagline: "SMOKE HASH STACK CASH — DROP 003",
    },
  },
  en: {
    nav: { drop: "DROP", lookbook: "LOOKBOOK", manifesto: "MANIFESTO", signup: "SIGN UP" },
    hero: {
      kicker: "DROP 003 — MOROCCAN COAST",
      lines: ["SMOKE", "HASH", "STACK", "CASH"],
      sub: "The first tee in SignUp history. A legendary item for chocolate lovers # <3 The raft sails Sept 14 at 14:20. We reach port at 22:00 to ship your packages before the morning transport leaves!",
      date: "SEP 14 — 14:20 CEST",
      cta1: "JOIN THE DROP LIST",
      cta2: "VIEW COLLECTION",
      live: "DROP IN",
    },
    countdown: { days: "DAYS", hours: "HRS", minutes: "MIN", seconds: "SEC", label: "LAUNCH — SEPTEMBER 14, 14:20", waiting: "PEOPLE WAITING FOR THE DROP", port: "PACKAGE DROP AT PORT — 22:00" },
    products: {
      kicker: "COLLECTION",
      title: "ONE TEE ON THIS DROP",
      tee: { name: "$MOKE HA$H STACK CA$H", price: "249 PLN", desc: "The first tee in SignUp history. A legendary item for chocolate lovers # <3 The raft sails Sept 14 at 14:20. We reach port at 22:00 to ship your packages before the morning transport leaves!", size: "SIZE", cta: "BUY NOW", available: "AVAILABLE", sizechart: "SIZE CHART", accuracy: "± 2 cm accuracy", sold: "SOLD", left: "LEFT", stockof: "OF 180 PCS", pcs: "PCS" },
      buy: { loading: "REDIRECTING…", error: "Payment temporarily unavailable — try again in a moment.", success: "Tee paid! Confirmation is on its way to your inbox.", cancel: "Payment cancelled — the tee waits for you." },
      soldout: "SOLD OUT",
    },
    modal: {
      title: "VIP LIST",
      sub: "Leave your email — you'll get the link 10 minutes before the drop. No spam, signal only.",
      placeholder: "you@email.com",
      submit: "NOTIFY ME",
      success: "You're on the list. See you Sept 14, 14:20.",
      duplicate: "This email is already on the VIP list.",
      error: "Something went wrong — try again.",
      invalid: "Enter a valid email address.",
    },
    manifesto: {
      kicker: "MANIFESTO",
      chapters: [
        { n: "01", title: "MOROCCAN DRIP", body: "A collection made for chocolate connoisseurs. If you're a frozen / static enthusiast, you'll definitely get the message." },
        { n: "02", title: "MADE IN POLAND FROM PREMIUM COTTON", body: "Premium 260 GSM cotton! A tee that won't shrink after a few washes, with a print that survives any conditions!" },
        { n: "03", title: "STACK CASH AND SMOKE HA$H!", body: "Heavily limited drop as always. Cop the tee and your Ca$h stacks way faster!" },
      ],
    },
    lookbook: { kicker: "LOOKBOOK", title: "ROUTE: MOROCCO TRAP → PL TRAPHOUSE", sub: "" },
    footer: {
      newsletter: "Newsletter — drop info only, zero spam.",
      placeholder: "you@email.com",
      submit: "SEND",
      rights: "© 2026 $IGN UP! — All rights reserved.",
      tagline: "SMOKE HASH STACK CASH — DROP 003",
    },
  },
};

export const DROP_DATE = "2026-09-14T14:20:00+02:00";
